import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CustomerEmojiBackground from 'components/icons/CustomerEmojiBackground';
const getRandomEmoji = () => {
  const emojiArray = ['😁', '😃', '😄', '😊', '😋', '😎', '😍', '🤗', '🤩', '😏', '😬', '🥳', '🤭'];
  const randomIndex = Math.floor(Math.random() * emojiArray.length);
  return emojiArray[randomIndex];
};
const RandomCustomerEmoji = t0 => {
  const $ = _c(12);
  const {
    customerName: t1
  } = t0;
  const customerName = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== customerName) {
    t2 = customerName.replace(/[. ]/gi, "").toLowerCase();
    $[0] = customerName;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const backgroundId = `RandomCustomerEmoji__background-${t2}`;
  const [emojiToRender, setEmojiToRender] = useState("");
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setEmojiToRender(getRandomEmoji());
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== customerName) {
    t4 = [setEmojiToRender, customerName];
    $[3] = customerName;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== backgroundId) {
    t5 = <CustomerEmojiBackground id={backgroundId} className="h-full w-full" />;
    $[5] = backgroundId;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== emojiToRender) {
    t6 = <span className="items-center bottom-0 flex text-[1.3rem] justify-center left-0 absolute right-0 top-0 md:text-[1.8rem]">{emojiToRender}</span>;
    $[7] = emojiToRender;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <span className="block h-[42px] relative w-[42px] md:h-[60px] md:w-[60px]">{t5}{t6}</span>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
RandomCustomerEmoji.propTypes = {
  customerName: PropTypes.string
};
export default RandomCustomerEmoji;